var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import BreakInDamageChoices from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageChoices.vue';
import { LITTLE_GATE_DAMAGE_SEVERITY_TRAD_KEYS_AND_IMAGES } from '@declaration/constants/breakInDamages/LittleGateConstants';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let LittleGateDamageSeverity = class LittleGateDamageSeverity extends Vue {
    constructor() {
        super(...arguments);
        this.showValidation = false;
        this.damageSeverityLevels = Object.entries(LITTLE_GATE_DAMAGE_SEVERITY_TRAD_KEYS_AND_IMAGES).map(([damageSeverity, description]) => ({
            value: damageSeverity,
            tradKey: description.tradKey,
            descriptionTradKey: description.descriptionTradKey,
            image: description.image,
        }));
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        return !this.validation.fieldHasViolations('damageSeverity');
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.$emit('goToNextStep');
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
};
__decorate([
    layout.State('color')
], LittleGateDamageSeverity.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], LittleGateDamageSeverity.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], LittleGateDamageSeverity.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], LittleGateDamageSeverity.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], LittleGateDamageSeverity.prototype, "validateBreakInDamage", void 0);
LittleGateDamageSeverity = __decorate([
    Component({
        components: {
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSectionCard,
            BreakInDamageChoices,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
            isSaving: { type: Boolean, default: false },
        },
    })
], LittleGateDamageSeverity);
export default LittleGateDamageSeverity;
